// Raw events data without status - status will be calculated dynamically
const eventsData = [
  {
    id: 1,
    name: "Brandons de Moudon",
    location: "Moudon",
    address: "Centre-ville de Moudon",
    dates: { start: "2026-03-06", end: "2026-03-08" },
    displayDates: "06 au 08 mars 2026",
    hours: "11h00 - 23h00",
    coordinates: { lat: 46.6689, lng: 6.7961 },
    type: "Festival",
    description: "Festival traditionnel vaudois avec ambiance carnavalesque"
  },
  {
    id: 2,
    name: "Brandons d'Yverdon-les-Bains",
    location: "Yverdon-les-Bains",
    address: "Place Pestalozzi, Yverdon-les-Bains",
    dates: { start: "2026-03-13", end: "2026-03-15" },
    displayDates: "13 au 15 mars 2026",
    hours: "11h00 - 00h00",
    coordinates: { lat: 46.7785, lng: 6.6410 },
    type: "Festival",
    description: "Le plus grand carnaval de la région avec défilés et festivités"
  },
  {
    id: 8,
    name: "Il était une fois",
    location: "Concise",
    address: "Concise, Vaud",
    dates: { start: "2026-05-01", end: "2026-05-03" },
    displayDates: "01 au 03 mai 2026",
    hours: "10h00 - 22h00",
    coordinates: { lat: 46.8503, lng: 6.7264 },
    type: "Festival",
    description: "Festival médiéval dans le cadre pittoresque de Concise au bord du lac de Neuchâtel"
  },
  {
    id: 3,
    name: "Foodies",
    location: "Yverdon-les-Bains",
    address: "Les Rives, Yverdon-les-Bains",
    dates: { start: "2026-05-08", end: "2026-05-10" },
    displayDates: "08 au 10 mai 2026",
    hours: "10h00 - 22h00",
    coordinates: { lat: 46.7795, lng: 6.6380 },
    type: "Festival",
    description: "Festival gastronomique réunissant les meilleurs food trucks de la région"
  },
  {
    id: 4,
    name: "AR Mood Festival",
    location: "Fleurier",
    address: "Fleurier, Val-de-Travers",
    dates: { start: "2026-05-29", end: "2026-05-31" },
    displayDates: "29 au 31 mai 2026",
    hours: "14h00 - 02h00",
    coordinates: { lat: 46.9042, lng: 6.5806 },
    type: "Festival",
    description: "Festival musical dans le cadre idyllique du Val-de-Travers"
  },
  {
    id: 5,
    name: "Événement Migros Signal de Bougy",
    location: "Bougy-Villars",
    address: "Signal de Bougy, Bougy-Villars",
    dates: { start: "2026-06-07", end: "2026-06-07" },
    displayDates: "07 juin 2026",
    hours: "10h00 - 18h00",
    coordinates: { lat: 46.4631, lng: 6.3764 },
    type: "Événement",
    description: "Journée familiale au parc Signal de Bougy"
  },
  {
    id: 6,
    name: "Portaz Air Festival",
    location: "Portalban",
    address: "Plage de Portalban",
    dates: { start: "2026-07-02", end: "2026-07-05" },
    displayDates: "02 au 05 juillet 2026",
    hours: "12h00 - 03h00",
    coordinates: { lat: 46.9167, lng: 6.9500 },
    type: "Festival",
    description: "Festival en plein air au bord du lac de Neuchâtel"
  },
  {
    id: 10,
    name: "La Dérivée",
    location: "Yverdon-les-Bains",
    address: "Quai de Nogent, Yverdon-les-Bains",
    dates: { start: "2026-07-09", end: "2026-07-10" },
    displayDates: "09 et 10 juillet 2026",
    hours: "11h00 - 23h00",
    coordinates: { lat: 46.7810, lng: 6.6390 },
    type: "Événement",
    description: "Événement festif sur le Quai de Nogent au bord du lac"
  },
  {
    id: 11,
    name: "Viva Festa",
    location: "Yverdon-les-Bains",
    address: "Place Pestalozzi, Yverdon-les-Bains",
    dates: { start: "2026-07-16", end: "2026-07-16" },
    displayDates: "16 juillet 2026",
    hours: "11h00 - 23h00",
    coordinates: { lat: 46.7785, lng: 6.6410 },
    type: "Événement",
    description: "Fête animée sur la Place Pestalozzi"
  },
  {
    id: 12,
    name: "Le Bouveret",
    location: "Le Bouveret",
    address: "Au Bouveret",
    dates: { start: "2026-07-31", end: "2026-07-31" },
    displayDates: "31 juillet 2026",
    hours: "11h00 - 22h00",
    coordinates: { lat: 46.3481, lng: 6.8567 },
    type: "Événement",
    description: "Événement au bord du lac Léman au Bouveret"
  },
  {
    id: 13,
    name: "La Plage",
    location: "Yverdon-les-Bains",
    address: "Plage d'Yverdon-les-Bains",
    dates: { start: "2026-08-01", end: "2026-08-01" },
    displayDates: "01 août 2026",
    hours: "10h00 - 22h00",
    coordinates: { lat: 46.7840, lng: 6.6330 },
    type: "Événement",
    description: "Fête nationale sur la plage d'Yverdon-les-Bains"
  },
  {
    id: 14,
    name: "La Dérivée",
    location: "Yverdon-les-Bains",
    address: "Quai de Nogent, Yverdon-les-Bains",
    dates: { start: "2026-08-13", end: "2026-08-15" },
    displayDates: "13 au 15 août 2026",
    hours: "11h00 - 23h00",
    coordinates: { lat: 46.7810, lng: 6.6390 },
    type: "Événement",
    description: "Événement festif sur le Quai de Nogent au bord du lac"
  },
  {
    id: 9,
    name: "FY Festival",
    location: "Yverdon-les-Bains",
    address: "La Marive, Yverdon-les-Bains",
    dates: { start: "2026-08-21", end: "2026-08-23" },
    displayDates: "21 au 23 août 2026",
    hours: "14h00 - 03h00",
    coordinates: { lat: 46.7830, lng: 6.6350 },
    type: "Festival",
    description: "Festival musical sur les rives du lac de Neuchâtel à La Marive"
  },
  {
    id: 7,
    name: "Marché de Noël",
    location: "Yverdon-les-Bains",
    address: "Place Pestalozzi, Yverdon-les-Bains",
    dates: { start: "2026-11-28", end: "2026-12-24" },
    displayDates: "28.11 au 24.12 2026",
    hours: "11h00 - 20h00",
    coordinates: { lat: 46.7785, lng: 6.6410 },
    type: "Marché",
    description: "Marché de Noël traditionnel avec ambiance festive"
  }
];

// Calculate event status dynamically based on current date
export const getEventStatus = (event) => {
  const now = new Date();
  const start = new Date(event.dates.start);
  const end = new Date(event.dates.end);
  // Add one day to end date to include the entire last day
  end.setHours(23, 59, 59, 999);
  
  if (now > end) return 'past';
  if (now >= start && now <= end) return 'active';
  return 'upcoming';
};

// Events with dynamically calculated status
export const events = eventsData.map(event => ({
  ...event,
  status: getEventStatus(event)
}));

// Function to refresh events with current status
export const getEventsWithCurrentStatus = () => {
  return eventsData.map(event => ({
    ...event,
    status: getEventStatus(event)
  }));
};

export const locations = [
  "Tous",
  "Moudon",
  "Yverdon-les-Bains",
  "Concise",
  "Fleurier",
  "Bougy-Villars",
  "Portalban",
  "Le Bouveret"
];

export const months = [
  { value: 0, label: "Mars", date: "2026-03-01" },
  { value: 1, label: "Avril", date: "2026-04-01" },
  { value: 2, label: "Mai", date: "2026-05-01" },
  { value: 3, label: "Juin", date: "2026-06-01" },
  { value: 4, label: "Juillet", date: "2026-07-01" },
  { value: 5, label: "Août", date: "2026-08-01" },
  { value: 6, label: "Sept", date: "2026-09-01" },
  { value: 7, label: "Oct", date: "2026-10-01" },
  { value: 8, label: "Nov", date: "2026-11-01" },
  { value: 9, label: "Déc", date: "2026-12-01" }
];

// Helper function to get event by date
export const getEventByDate = (date) => {
  const targetDate = new Date(date);
  return events.find(event => {
    const start = new Date(event.dates.start);
    const end = new Date(event.dates.end);
    return targetDate >= start && targetDate <= end;
  });
};

// Helper function to get closest event to a date
export const getClosestEvent = (date) => {
  const targetDate = new Date(date);
  let closestEvent = events[0];
  let minDiff = Infinity;

  events.forEach(event => {
    const eventDate = new Date(event.dates.start);
    const diff = Math.abs(targetDate - eventDate);
    if (diff < minDiff) {
      minDiff = diff;
      closestEvent = event;
    }
  });

  return closestEvent;
};

// Helper to get the next upcoming event based on real-time
export const getNextEvent = () => {
  const now = new Date();
  const currentEvents = getEventsWithCurrentStatus();
  
  // First check for active events
  const activeEvent = currentEvents.find(event => event.status === 'active');
  if (activeEvent) return activeEvent;
  
  // Then find next upcoming event
  const upcoming = currentEvents
    .filter(event => event.status === 'upcoming')
    .sort((a, b) => new Date(a.dates.start) - new Date(b.dates.start));
  
  return upcoming[0] || currentEvents[currentEvents.length - 1];
};

// Get current date/time formatted
export const getCurrentDateTime = () => {
  const now = new Date();
  return {
    date: now.toLocaleDateString('fr-CH', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    }),
    time: now.toLocaleTimeString('fr-CH', { 
      hour: '2-digit', 
      minute: '2-digit' 
    })
  };
};

// Contact info
export const contactInfo = {
  name: "L'Atelier by JS",
  tagline: "Food Truck & Traiteur raffiné",
  slogan: "Fait maison • Raffiné • Artisanal",
  address: "Rue des Jordils 51A, 1400 Yverdon-les-Bains, Suisse",
  phone: "078 898 19 02",
  email: "info@atelierjs.ch",
  website: "www.atelierjs.ch",
  instagram: "@latelierbyjs",
  founders: "Sophie & Jérémy"
};

// Assets
export const assets = {
  truckImage: "https://customer-assets.emergentagent.com/job_58da12ea-9dd5-4e36-86dd-f676736eb745/artifacts/55yzm6je_Design%20sans%20titre.png",
  logo: "https://customer-assets.emergentagent.com/job_roaming-atelier/artifacts/99db98xy_LOGO%20CIRCLE%40300x.png"
};
